import { render } from "./AiPromptSetting.vue?vue&type=template&id=280d5266&scoped=true"
import script from "./AiPromptSetting.vue?vue&type=script&lang=js"
export * from "./AiPromptSetting.vue?vue&type=script&lang=js"

import "./AiPromptSetting.vue?vue&type=style&index=0&id=280d5266&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280d5266"]])

export default __exports__